<template>
    <modal name="modalKemasan" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("kemasan") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>


                    <form class="forms-sample" @submit.prevent="submitData" method="POST" enctype="multipart/form-data">

                        <div class="modal-body">


                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('seri') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('seri')"
                                    v-model="form_kemasan.seriKemasan" disabled />
                                <div v-if="errors.seriKemasan">
                                    <div v-for="error in errors.seriKemasan" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('jumlah') }} </label>
                                <input type="number" class="form-control" :id="this.$dynamicId()"
                                    :placeholder="$t('jumlah')" v-model="form_kemasan.jumlahKemasan" required
                                    maxlength="255" />
                                <div v-if="errors.jumlahKemasan ">
                                    <div v-for="error in errors.jumlahKemasan" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('jenis') }} </label>

                                <v-select :options="fetchJenis" v-model="jenisKemasan" label="label" return-object :filter-by="customSearch">
                                </v-select>

                                <div v-if="errors.kodeJenisKemasan">
                                    <div v-for="error in errors.kodeJenisKemasan" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('merk') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('merk')"
                                    v-model="form_kemasan.merkKemasan" maxlength="255" @input="forceUpper($event, form_kemasan, 'merkKemasan')" />
                                <div v-if="errors.merkKemasan">
                                    <div v-for="error in errors.merkKemasan" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                                this.$t("close_txt") }}</button>
                            <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalKemasan",
    props: {
        docForm: { type: [Object, Array] }
    },
    data() {
        return {
            form_kemasan: [],
            errors: [],

            fetchJenis: [],
            jenisKemasan: null,
        }
    },
    methods: {
        customSearch(option, label, search) {
            let temp = search.toLowerCase();
            return option.code.toLowerCase().indexOf(temp) > -1 ||
                option.name.toLowerCase().indexOf(temp) > -1
        },
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        removeModals() {
            this.$modal.hide('modalKemasan');
        },
        asyncJenisKemasan() {

            this.fetchJenis = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodeJenisKemasan";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchJenis.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        submitData() {
            this.form_kemasan.kodeJenisKemasan = this.jenisKemasan?.code;
            this.form_kemasan.namaJenisKemasan = this.jenisKemasan?.name;

            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-6-kemasan";
            this.$http.post(baseURI, this.form_kemasan, { timeout: 100000 }).then((response) => {
                if (response.data.status === 200) {
                    this.isLoading = false;
                    this.errors = [];
                    this.removeModals();
                    this.$emit("setValue");
                    this.form_kemasan = [];
                    this.jenisKemasan = null;
                } else {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
    created() {
        this.asyncJenisKemasan();
    },
    watch: {
        docForm: function (newVal) {
            this.form_kemasan = newVal;
            if (newVal.kodeJenisKemasan == null || newVal.kodeJenisKemasan == "") {
                this.jenisKemasan = null;
            } else {
                this.jenisKemasan = { code: newVal.kodeJenisKemasan, name: newVal.namaJenisKemasan, label: newVal.kodeJenisKemasan + " - " + newVal.namaJenisKemasan };
            }
        },
    },
}
</script>

<style></style>